package br.com.texeratx.boardgametimeapp.data.model.login

import kotlinx.serialization.Serializable

@Serializable
data class LoginResponse(
    val token: String,
    val userId: Long,
    val email: String,
    val displayName: String,
    val imageUrl: String? = null
)
